import { Component, OnInit, Input, HostListener } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Lightbox } from 'ngx-lightbox';

import { Product } from 'src/app/shared/classes/product';
import { ApiService } from 'src/app/shared/services/api.service';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'product-gallery-default',
	templateUrl: './gallery-default.component.html',
	styleUrls: ['./gallery-default.component.scss']
})

export class GalleryDefaultComponent implements OnInit {

	@Input() product: Product;
	@Input() adClass = 'product-gallery-vertical';
	

	paddingTop = '100%';
	currentIndex = 0;
	album = [];
	lightBoxOption = {
		showImageNumberLabel: true,
		centerVertically: true,
		showZoom: true,
		fadeDuration: .2,
		albumLabel: "%1 / %2"
	}

	SERVER_URL = environment.SERVER_URL;	

	showStock:boolean;	
	videoURL : SafeResourceUrl;
	public allRelatedOutofStock:boolean = false;

	constructor(public lightBox: Lightbox,private apiService:ApiService, public sanitiser:DomSanitizer) { 		
	}

	@HostListener('window:resize', ['$event'])
	closeLightBox(event: Event) {
		this.lightBox.close();
	}

	ngOnChanges() {
		this.album = [];
		for (let i = 0; i < this.product.pictures.length; i++) {
			this.album.push({
				src: this.SERVER_URL + this.product.pictures[i].url,
				thumb: this.SERVER_URL + this.product.sm_pictures[i].url,
				caption: this.product.name
			});
		}
	}

	ngOnInit(): void {
		this.paddingTop = Math.floor((parseFloat(this.product.pictures[0].height.toString()) / parseFloat(this.product.pictures[0].width.toString()) * 1000)) / 10 + '%';
		this.showStock=this.apiService.showStock;		
		/**
		 * check if product has variants and if all variants are out of stock
		 */
		let counter=0;		
		if(this.product.var_rel != null){
			this.product.var_rel.forEach(element => {
				if(element.stock===0)
					counter++;                                                        				    
			});		
			if(counter === this.product.var_rel.length)
				this.allRelatedOutofStock = true;   	
		}
		
	}

	changeImage($event: Event, index = 0, item) {
		this.currentIndex = index;
		this.extractSrcUrl(item);
		//this.videoURL = this.sanitiser.bypassSecurityTrustResourceUrl(this.product.videoURL.toString());
		$event.preventDefault();
	}

	openLightBox() {
		if(!this.apiService.selectedRelated.name)		
			this.lightBox.open(this.album, this.currentIndex, this.lightBoxOption);
		else{
			this.album = [];
			for (let i = 0; i < this.apiService.selectedRelated.pictures.length; i++) {
				this.album.push({
					src: this.apiService.selectedRelated.pictures[i].url.toString().startsWith('https://img.youtube') ? this.apiService.selectedRelated.sm_pictures[i].url : (this.SERVER_URL + this.apiService.selectedRelated.pictures[i].url),
					thumb: this.apiService.selectedRelated.pictures[i].url.toString().startsWith('https://img.youtube') ? this.apiService.selectedRelated.sm_pictures[i].url : (this.SERVER_URL + this.apiService.selectedRelated.sm_pictures[i].url),
					caption: this.apiService.selectedRelated.name
				});				
			}
			this.lightBox.open(this.album, this.currentIndex, this.lightBoxOption);
		}
	}

	public extractSrcUrl(prod: any) {
		//console.log('executed');
		let iframeString = prod.videoURL;		
		const srcRegex = /src="(.*?)"/;
		const match = srcRegex.exec(iframeString);
		if (match && match.length > 1) {
		  let url = match[1];
		  this.videoURL = this.sanitiser.bypassSecurityTrustResourceUrl(url);
		} 				
	}
}